
export default function ProductOverview() {
  const features = [
    {
      icon: 'ri-leaf-fill',
      title: '100% Recycled Kraft',
      description: 'Made from post-consumer recycled materials, reducing environmental impact'
    },
    {
      icon: 'ri-shield-check-fill',
      title: 'High-Quality Paper',
      description: '70 lbs paper weight ensures durability and strength for heavy groceries'
    },
    {
      icon: 'ri-recycle-fill',
      title: 'Biodegradable',
      description: 'Naturally decomposes without harming the environment'
    },
    {
      icon: 'ri-paint-brush-fill',
      title: 'Custom Printing',
      description: 'Add your brand logo and design to create unique packaging'
    },
    {
      icon: 'ri-price-tag-3-fill',
      title: 'Affordable & Durable',
      description: 'Cost-effective solution without compromising on quality'
    },
    {
      icon: 'ri-flag-fill',
      title: 'Made in USA',
      description: 'Proudly manufactured domestically with quality materials'
    }
  ];

  return (
    <section id="products" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#5a7c3e] mb-4">
            Our <strong>Paper Bags</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Premium <strong>eco-friendly grocery bags</strong> designed for retailers, grocery stores, and businesses seeking <strong>sustainable packaging solutions</strong>
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <img
              src="https://static.readdy.ai/image/d32fda172531ebc64455c87992c4a988/23237e79778783749dba91d5a346b039.jpeg"
              alt="Paper grocery bags with fresh produce"
              className="w-full h-[500px] object-cover object-top rounded-2xl shadow-xl"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="800" height="900" viewBox="0 0 800 900"%3E%3Crect fill="%23f5f5f5" width="800" height="900"/%3E%3Ctext fill="%23999" x="50%" y="50%" font-family="Arial" font-size="20" text-anchor="middle" dominant-baseline="middle"%3EImage not available%3C/text%3E%3C/svg%3E';
              }}
            />
          </div>
          <div className="space-y-6">
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              <strong>Eco-Friendly Grocery Solution</strong>
            </h3>
            <p className="text-base text-gray-700 leading-relaxed">
              By using <strong>paper grocery bags</strong>, you contribute to reducing plastic waste and promoting a <strong>sustainable environment</strong>. They are recyclable, biodegradable, and a better choice for our planet's health.
            </p>
            <div className="bg-[#f5f8f2] p-6 rounded-xl">
              <h4 className="text-xl font-bold text-[#5a7c3e] mb-4">Product Specifications</h4>
              <ul className="space-y-3 text-sm text-gray-700">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-[#5a7c3e] text-lg mt-0.5"></i>
                  <span><strong>Handle type:</strong> Spiral twisted paper handles</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-[#5a7c3e] text-lg mt-0.5"></i>
                  <span><strong>Quantity:</strong> 250 pieces per carton</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-[#5a7c3e] text-lg mt-0.5"></i>
                  <span><strong>Available sizes:</strong></span>
                </li>
                <li className="ml-8 text-sm">
                  <div className="space-y-1">
                    <div>#14 (14 x 10 x 15.5)</div>
                    <div>#12 (12.85 x 7 x 13)</div>
                    <div>#10 (10 x 6.75 x 12)</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 p-8 rounded-xl hover:shadow-lg transition-shadow"
            >
              <div className="w-14 h-14 bg-[#5a7c3e]/10 rounded-lg flex items-center justify-center mb-5">
                <i className={`${feature.icon} text-2xl text-[#5a7c3e]`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
